<template>
  <v-container class="grey lighten-5">
    <h2>Paketverwaltung</h2>
    <br/>
    <v-data-table
        :headers="standardHeaders"
        :items="packages"
        :search="search"
        :items-per-page="15"
        class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
            append-icon="mdi-magnify"
            v-model="search"
            single-line
            label="Suche"
            class="mx-4"
        />
      </template>

      <template v-slot:item.open="{ item }">
        <v-btn
            @click="openPackage(item)"
            class="ma-2"
            outlined
            x-small
            fab
            color="indigo"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-btn class="ma-2" color="indigo" x-small fab outlined @click="deletePackage(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

    </v-data-table>

    <v-file-input
        truncate-length="24"
        accept="application/zip"
        @change="fileSelected"
        label="ZIP Datei auswählen"
    ></v-file-input>
    <v-btn class="ma-1" color="info" :loading="loading"
           :disabled="loading || zip===null" @click="uploadPackage">
      Paket hochladen
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <v-progress-linear
        class="ma-1"
        v-if="loading"
        v-model="progress"
        height="25"
    >
      <strong>{{ Math.ceil(progress) }}%</strong>
    </v-progress-linear>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>

    <CourseRun style="width: 100%; height: 500px" v-if="preview" :item="preview"/>
  </v-container>

</template>

<script>

import CourseRun from "@/components/CourseExecution.vue";
import Course from "@/models/Course";
import {default as CourseRunModel} from "@/models/CourseRun";

export default {
  name: "SuperAdminPackageSettings",
  components: {CourseRun},
  data: () => ({
    packages: [],
    loading: false,
    zip: null,
    search: '',
    preview: null,
    error: false,
    success: false,
    progress: 0,
    errorText: "",
    successText: "Erfolgreich hochgeladen",
    standardHeaders: [
      {
        text: "Titel",
        value: "title",
      },
      {
        text: "Ansehen", value: "open",
        sortable: false,
      },
      {
        text: "Löschen", value: "delete",
        sortable: false,
      },
    ]
  }),
  methods: {
    uploadPackage() {
      console.log(this.zip);
      this.loading = true;
      this.$httpCoursePackageApi.upload(this.zip, (progress) => {
        this.progress = Math.round((100 * progress.loaded) / progress.total);
      }, () => {
        this.loading = false;
        this.successText = "Erfolgreich hochgeladen"
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.zip = null;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler beim Hochladen der Datei."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    openPackage(file) {
      let ref = this;
      this.preview = null;
      setTimeout(function () {
        ref.preview = new CourseRunModel({course: new Course({webLink: "/courseContent/" + ref.htmlEntities(file.title) + "/res/index.html"})})
      }, 1000);
    },
    htmlEntities(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    fileSelected(file) {
      this.zip = file;
    },
    deletePackage(file) {
      this.$httpCoursePackageApi.delete(file.title, () => {
        this.loadData();
        this.successText = "Erfolgreich gelöscht"
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      }, () => {
        this.errorText = "Fehler beim Löschen."
        this.error = true;
        setTimeout(() => this.error = false, 3000);
      })
    },
    loadData() {
      this.$httpCoursePackageApi.getAll((result) => {
        this.packages = result.map((date) => {
          let result = {"title": date}
          return result
        });
      })
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
